module.exports = __webpack_public_path__ + "static/media/image3.ae855861.png";